var m = Object.defineProperty;
var f = (n, e, t) => e in n ? m(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var o = (n, e, t) => (f(n, typeof e != "symbol" ? e + "" : e, t), t);
let d;
const w = new Uint8Array(16);
function I() {
  if (!d && (d = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !d))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return d(w);
}
const r = [];
for (let n = 0; n < 256; ++n)
  r.push((n + 256).toString(16).slice(1));
function b(n, e = 0) {
  return (r[n[e + 0]] + r[n[e + 1]] + r[n[e + 2]] + r[n[e + 3]] + "-" + r[n[e + 4]] + r[n[e + 5]] + "-" + r[n[e + 6]] + r[n[e + 7]] + "-" + r[n[e + 8]] + r[n[e + 9]] + "-" + r[n[e + 10]] + r[n[e + 11]] + r[n[e + 12]] + r[n[e + 13]] + r[n[e + 14]] + r[n[e + 15]]).toLowerCase();
}
const p = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), v = {
  randomUUID: p
};
function g(n, e, t) {
  if (v.randomUUID && !e && !n)
    return v.randomUUID();
  n = n || {};
  const i = n.random || (n.rng || I)();
  if (i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, e) {
    t = t || 0;
    for (let s = 0; s < 16; ++s)
      e[t + s] = i[s];
    return e;
  }
  return b(i);
}
class k {
  constructor(e, t) {
    o(this, "events");
    o(this, "config");
    o(this, "timeout");
    o(this, "user");
    o(this, "requestInFlight");
    this.user = t, this.config = e, this.events = [], this.timeout = 0, this.requestInFlight = !1, this.setSendInterval();
  }
  pushEvent({ label: e = "", type: t, metaData: i = {} }) {
    const { window: s, getCustomMetaData: c } = this.config, { width: a, height: l } = s.screen, h = {
      label: e,
      sessionId: this.user.getSessionId(),
      fallbackId: this.user.getFallbackId(),
      timestamp: Date.now(),
      view: s.location.pathname.replace(/\/$/, ""),
      search: s.location.search,
      type: t,
      screen: {
        width: a,
        height: l
      },
      userAgent: s.navigator.userAgent,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      id: g(),
      metaData: i
    }, u = {
      ...h,
      metaData: Object.assign(i, c == null ? void 0 : c(h))
    };
    this.events.push(u);
  }
  onShutDown() {
    const { window: e } = this.config;
    e.clearInterval(this.timeout), this.flush();
  }
  setSendInterval() {
    const { window: e, flushInterval: t } = this.config;
    this.timeout = e.setInterval(this.flush.bind(this), t);
  }
  async flush() {
    const { debug: e, request: t } = this.config;
    if (!(this.events.length === 0 || this.requestInFlight))
      try {
        const i = [...this.events];
        e && console.info("Sending ui events", i), this.requestInFlight = !0, await t(i), this.events = this.events.filter(
          (s) => i.every((c) => s.id !== c.id)
        );
      } catch {
      } finally {
        this.requestInFlight = !1;
      }
  }
}
const E = (n, e = 500) => {
  let t;
  return (...i) => {
    clearTimeout(t), t = window.setTimeout(n, e, ...i);
  };
}, S = (n, e = 500) => {
  let t = !1;
  return (...i) => {
    t || (n(...i), t = !0, setTimeout(() => t = !1, e));
  };
};
class y {
  constructor(e, t) {
    o(this, "config");
    o(this, "eventHandler");
    o(this, "mutationObserver");
    o(this, "clickHandlers");
    this.config = e, this.eventHandler = t, this.clickHandlers = /* @__PURE__ */ new Map(), this.mutationObserver = new MutationObserver(
      E(this.onDomChange.bind(this))
    ), this.config.window.addEventListener("load", this.onLoad.bind(this));
  }
  onLoad() {
    const { debug: e } = this.config;
    e && console.time("onLoadExecutionTime"), this.onDomChange(), this.mutationObserver.observe(this.config.window.document.body, {
      subtree: !0,
      childList: !0
    }), e && console.timeEnd("onLoadExecutionTime");
  }
  onShutDown() {
    this.removeClickListeners(), this.mutationObserver.disconnect();
  }
  onDomChange() {
    var c;
    const {
      window: { document: e },
      labelAttribute: t,
      debug: i
    } = this.config;
    i && console.time("elementRefreshExecutionTime"), this.removeClickListeners(), ((c = Array.from(
      e.querySelectorAll(
        `*[${t}], button, a`
      )
    )) != null ? c : []).forEach((a) => {
      const l = S(this.clickHandler.bind(this));
      this.clickHandlers.set(a, l), a.addEventListener("click", l);
    }), i && console.timeEnd("elementRefreshExecutionTime");
  }
  removeClickListeners() {
    for (const [e, t] of this.clickHandlers)
      e.removeEventListener("click", t);
    this.clickHandlers.clear();
  }
  clickHandler(e) {
    const t = e.currentTarget;
    if (!t || !this.validateClick(t))
      return;
    const i = this.getLabel(t);
    !i || this.eventHandler.pushEvent({ label: i, type: "click" });
  }
  getLabel(e) {
    var i;
    const { labelAttribute: t } = this.config;
    return (i = e.getAttribute(t)) != null ? i : e.innerText;
  }
  validateClick(e) {
    var t;
    return ((t = e.parentElement) == null ? void 0 : t.nodeName.toLowerCase()) !== "a";
  }
}
const L = "events-user-id", H = "events-session-id";
class D {
  constructor(e) {
    o(this, "config");
    o(this, "fallbackId");
    o(this, "sessionId");
    this.config = e, this.fallbackId = this.getInitialStorageId("localStorage", L), this.sessionId = this.getInitialStorageId("sessionStorage", H);
  }
  getFallbackId() {
    return this.fallbackId;
  }
  getSessionId() {
    return this.sessionId;
  }
  getInitialStorageId(e, t) {
    const { debug: i, window: s } = this.config;
    try {
      const c = s[e];
      let a = c.getItem(t);
      return a || (a = g(), c.setItem(t, a)), a;
    } catch (c) {
      return i && console.info("Failed to get/set item in storage", c), g();
    }
  }
}
class U {
  constructor(e, t) {
    o(this, "config");
    o(this, "urlCheckInterval");
    o(this, "eventHandler");
    o(this, "location");
    this.config = e, this.eventHandler = t, this.addNavigationListener();
  }
  onShutdown() {
    this.removeNavigationListener();
  }
  removeNavigationListener() {
    const { window: e } = this.config;
    e.clearInterval(this.urlCheckInterval);
  }
  addNavigationListener() {
    const { window: e } = this.config;
    this.urlCheckInterval = e.setInterval(
      this.navigationHandler.bind(this),
      1e3
    );
  }
  navigationHandler() {
    const { window: e, debug: t } = this.config;
    e.location.href !== this.location && (t && console.info(
      `Identified a route change from ${this.location} to ${e.location.href}`
    ), this.eventHandler.pushEvent({ type: "navigation" }), this.location = e.location.href);
  }
}
const x = ({
  flushInterval: n = 5e3,
  labelAttribute: e = "data-loglabel",
  debug: t = !1,
  ...i
}) => {
  const s = {
    flushInterval: n,
    labelAttribute: e,
    debug: t,
    ...i
  }, c = new D(s), a = new k(s, c), l = new y(s, a), h = new U(s, a);
  return t && console.info("Initiated Ui Events with the following config", s), {
    shutdown: () => {
      a.onShutDown(), l.onShutDown(), h.onShutdown();
    },
    pushEvent: (u) => a.pushEvent(u)
  };
};
export {
  x as initEvents
};
